import { apiClient } from '@copro/api'
import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import z from 'zod'
import { useRouterLinkClick } from '../../../hooks/useRouterLinkClick'

const formSchema = z.object({
  email: z.email('Adresse email invalide, par exemple : nom@exemple.fr'),
})

type FormValues = z.infer<typeof formSchema>

export function useForgotPasswordPage() {
  const [isSent, setIsSent] = useState(false)
  const [serverError, setServerError] = useState<string | null>(null)
  const handleBackClick = useRouterLinkClick('/login')

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: { email: '' },
  })

  async function sendResetLink(data: FormValues) {
    setServerError(null)
    setIsSent(false)

    const { error } = await apiClient.auth.resetPasswordForEmail(data.email, {
      redirectTo: `${window.location.origin}/reset-password`,
    })

    if (error) {
      setServerError(error.message)
      return
    }
    setIsSent(true)
  }

  return {
    form,
    isSent,
    serverError,
    isSubmitting: form.formState.isSubmitting,
    handleSubmit: form.handleSubmit(sendResetLink),
    handleBackClick,
  }
}
